import React from 'react';
import Svg from '../shared/Svg';
import colors from '../../utils/colors';
import PropTypes from 'prop-types';
import './Search.scss';

export const Search = ({ onSearchCallback, searchQuery = '', searchPlaceholder, 'data-testid': testId }) => {
  const clearSearch = () => {
    onSearchCallback('');
  };

  const searchIconPath = searchQuery ? '/assets/backArrow.svg' : '/assets/search.svg';
  return (
    <div className='search-container'>
      <button className={`search-button ${searchQuery && 'search-isQuerying'}`}
        data-testid={testId ? `${testId}-reset-button` : undefined}
        onClick={clearSearch}>
        <Svg
          className='search-button'
          data={searchIconPath}
          fill={colors.searchGrey}
          hoverable
          hoverFill={colors.iconHover}
          onClick={clearSearch}
        />
      </button>
      <input className='search-input'
        data-testid={testId}
        value={searchQuery}
        onChange={(e) => onSearchCallback(e.target.value)}
        type="text"
        placeholder={searchPlaceholder}
        name="search"
      />
      { searchQuery.length >= 3 &&
        <button
          className='search-button'
          data-testid={testId ? `${testId}-clear-button` : undefined}
          onClick={() => onSearchCallback('') }>
          <Svg
            className='search-button'
            data='/assets/clear.svg'
            fill={colors.searchGrey}
            hoverable
            onClick={() => onSearchCallback('') }
            hoverFill={colors.iconHover}
          />
        </button>
      }
    </div>
  );
};

Search.propTypes = {
  'data-testid': PropTypes.string,
  onSearchCallback: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  searchQuery: PropTypes.string,
};
